import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { SpecificationModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import { ProductDetailsSpecificationsStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsSpecifications";
import Link from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import dropRight from "lodash/dropRight";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    specificationName = "specificationName",
}

export interface SpecificSpecificationStyles {
    specificSpecificationTitleStyles: ProductDetailsSpecificationsStyles;
    wrapper?: InjectableCss;
}

export const specificSpecificationStyles: SpecificSpecificationStyles = {
    specificSpecificationTitleStyles: {},
    wrapper: {
        css: css`
            margin-top: 50px;
        `,
    },
};

const styles = specificSpecificationStyles;

type Props = HasProduct & WidgetProps;

const SingleProductSpecification: React.FC<Props> = ({
    product: { specifications },
    fields: { specificationName },
}) => {
    const specificationsDisplay = specifications?.filter(spec => spec.nameDisplay === specificationName);
    const renderBottomCoverageCalculatorLink = (specification: SpecificationModel) => {
        if (typeof parse(specification.htmlContent, parserOptions) === "string") {
            return (
                <a
                    href={parse(specification.htmlContent, parserOptions) as string}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src="UserFiles\gemeco\site content\gemeco_beams.png"
                        alt="Bottom Coverage Calculator"
                        height="364px"
                        width="288px"
                    />
                </a>
            );
        }
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            {specificationsDisplay?.map((specification, index) => (
                <div
                    id={`spec_${index}`}
                    key={specification.nameDisplay}
                    style={{ textAlign: "center", marginTop: "20px;" }}
                >
                    {specification.nameDisplay === "Bottom Coverage Calculator" ? (
                        renderBottomCoverageCalculatorLink(specification)
                    ) : (
                        <p>{parse(specification.htmlContent, parserOptions)}</p>
                    )}
                </div>
            ))}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(SingleProductSpecification),
    definition: {
        displayName: "Single Product Specification",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.specificationName,
                editorTemplate: "TextField",
                fieldType: "General",
                defaultValue: "MAP Price",
            },
        ],
    },
};

export default widgetModule;
